module.exports = __webpack_public_path__ + "static/assets/22fbd0a5bc8f309a13c68f5dd7bb63f0.png";